import { render, staticRenderFns } from "./WFConfigEdit.vue?vue&type=template&id=62f21e80&"
import script from "./WFConfigEdit.vue?vue&type=script&lang=js&"
export * from "./WFConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports